export default __webpack_public_path__ + "medium-low-density.png";